/* unplugin-vue-components disabled */import { render } from "./address_picker.vue?vue&type=template&id=3c514af5"
import script from "./address_picker.vue?vue&type=script&lang=js"
export * from "./address_picker.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__